const DDD_UF = {
  SP: [11, 12, 13, 14, 15, 16, 17, 18, 19], RJ: [21, 22, 24], ES: [27, 28], MG: [31, 32, 33, 34, 35, 37, 38],
  PR: [41, 42, 43, 44, 45, 46], SC: [47, 48, 49], RS: [51, 53, 54, 55], DF: [61], GO: [62, 64], TO: [63],
  MT: [65, 66], MS: [67], AC: [68], RO: [69], BA: [71, 73, 74, 75, 77], SE: [79], PE: [81, 87], AL: [82],
  PB: [83], RN: [84], CE: [85, 88], PI: [86, 89], PA: [91, 93, 94], AM: [92, 97], RR: [95], AP: [96], MA: [98, 99],
};
const MAP = Object.fromEntries(Object.entries(DDD_UF).flatMap(([uf, list]) => list.map((d) => [String(d), uf])));
const CITY = { 11: "São Paulo", 21: "Rio de Janeiro", 31: "Belo Horizonte", 41: "Curitiba", 51: "Porto Alegre", 61: "Brasília", 71: "Salvador", 81: "Recife", 85: "Fortaleza", 91: "Belém", 92: "Manaus", 62: "Goiânia", 27: "Vitória", 48: "Florianópolis", 98: "São Luís" };

export const dddUF = (ddd) => MAP[String(ddd)] || "";
export const dddLabel = (ddd) => `${dddUF(ddd) || "?"}${CITY[ddd] ? ` · ${CITY[ddd]}` : ""}`;
